/* eslint-disable */
import React from 'react';

export function orderStatus(order, viewmode) {
  if (order.order_status === 'IV_Req') {
    const now = new Date();
    if (order.api_paymentstatus !== 'Success' && order.api_paymentstatus !== 'Cancel') {
      if (order.payment_method === 'cash' && order.payslip_submit === true) {
        return <div className='status-badge font-th status-badge-pending'>รอตรวจสอบสลิป</div>;
      }
      if (order.expiretime && new Date(order.expiretime) < now) {
        return <div className='status-badge font-th status-badge-error'>หมดอายุชำระเงิน</div>;
      }
    }

    if (order.api_paymentstatus === 'Success') {
      return <div className='status-badge font-th status-badge-info'>รอผู้ขายตอบรับคำสั่งซื้อ</div>;
    } else if (order.api_paymentstatus === 'Fail') {
      return <div className='status-badge font-th status-badge-error'>ชำระเงินไม่สำเร็จ</div>;
    } else if (order.api_paymentstatus === 'Cancel') {
      return <div className='status-badge font-th status-badge-gray'>ลูกค้ายกเลิกการชำระเงิน</div>;
    } else if (order.api_paymentstatus === 'Error') {
      return <div className='status-badge font-th status-badge-error'>เกิดข้อผิดพลาด</div>;
    } else if (order.api_paymentstatus === 'Transaction Pending') {
      return <div className='status-badge font-th status-badge-pending'>รอการชำระค่าสินค้า</div>;
    } else if (order.api_paymentstatus === 'Void Success') {
      return <div className='status-badge font-th status-badge-success'>Void สำเร็จ </div>;
    } else if (order.api_paymentstatus === 'Refund Success') {
      return <div className='status-badge font-th status-badge-success'>Refund สำเร็จ</div>;
    } else if (order.api_paymentstatus === 'Request to Refund') {
      return <div className='status-badge font-th status-badge-pending'>กำลังขอ Refund</div>;
    } else if (order.api_paymentstatus === 'Settlement Success') {
      return <div className='status-badge font-th status-badge-success'>โอนเงินให้ร้านค้าสำเร็จ</div>;
    } else if (order.api_paymentstatus === 'Void Fail') {
      return <div className='status-badge font-th status-badge-error'>Void ไม่สำเร็จ</div>;
    } else if (order.api_paymentstatus === 'Refund Fail') {
      return <div className='status-badge font-th status-badge-error'>Refund ไม่สำเร็จ</div>;
    } else {
      return <div className='status-badge font-th status-badge-gray'>ไม่ทราบสถานะการชำระเงิน</div>;
    }
  } else if (order.order_status === 'IV_EXP') {
    return <div className='status-badge font-th status-badge-error'>เกินระยะเวลาชำระ</div>;
  } else if (order.order_status === 'IV_ERR') {
    return <div className='status-badge font-th status-badge-error'>ผิดพลาด(ยกเลิกอัตโนมัติ)</div>;
  } else if (order.order_status === 'IV_Cancel') {
    return <div className='status-badge font-th status-badge-gray'>ผู้ซื้อยกเลิกคำสั่งซื้อ</div>;
  } else if (order.order_status === 'IV_Exp') {
    return <div className='status-badge font-th status-badge-error'>หมดอายุชำระเงิน</div>;
  } else if (order.order_status === 'IV_C_Cancel') {
    return <div className='status-badge font-th status-badge-gray'>ผู้ซื้อยกเลิกคำสั่งซื้อ</div>;
  } else if (order.order_status === 'IV_V_Cancel') {
    return <div className='status-badge font-th status-badge-gray'>ผู้ขายยกเลิกคำสั่งซื้อ</div>;
  } else if (order.order_status === 'IV_Refunded') {
    return (
      <div className='status-badge font-th status-badge-success'>คืนเงินที่ผู้ซื้อยกเลิกสำเร็จ</div>
    );
  } else if (order.order_status === 'PC_Prepare') {
    return <div className='status-badge font-th status-badge-info'>ผู้ขายตอบรับคำสั่งซื้อแล้ว</div>;
  } else if (order.order_status === 'PC_C_Cancel_Req') {
    return <div className='status-badge font-th status-badge-pending'>ผู้ซื้อขอยกเลิกคำสั่งซื้อ</div>;
  } else if (order.order_status === 'PC_C_Cancel_AC') {
    return (
      <div className='status-badge font-th status-badge-gray'>ผู้ขายตอบรับการยกเลิกคำสั่งซื้อ</div>
    );
  } else if (order.order_status === 'PC_V_Cancel') {
    return <div className='status-badge font-th status-badge-gray'>ผู้ขายยกเลิกคำสั่งซื้อ</div>;
  } else if (order.order_status === 'PC_C_Cancel_AT') {
    return <div className='status-badge font-th status-badge-gray'>ยกเลิกคำสั่งซื้ออัตโนมัติ</div>;
  } else if (order.order_status === 'PC_Book') {
    return <div className='status-badge font-th status-badge-info'>ผู้ขายกำลังเตรียมพัสดุ</div>;
  } else if (order.order_status === 'PC_C_Book_Cancel_Req') {
    return <div className='status-badge font-th status-badge-pending'>ผู้ซื้อขอยกเลิกคำสั่งซื้อ</div>;
  } else if (order.order_status === 'PC_C_Book_Cancel_AC') {
    return (
      <div className='status-badge font-th status-badge-gray'>ผู้ขายตอบรับการยกเลิกคำสั่งซื้อ</div>
    );
  } else if (order.order_status === 'PC_BookConfirm') {
    if (order.shipping_status === 'pending') {
      return <div className='status-badge font-th status-badge-info'>กำลังจัดส่ง</div>;
    } else if (order.shipping_status === 'booking') {
      return <div className='status-badge font-th status-badge-info'>กำลังจัดส่ง</div>;
    } else if (order.shipping_status === 'shipping') {
      return <div className='status-badge font-th status-badge-info'>อยู่ระหว่างขนส่ง</div>;
    } else if (order.shipping_status === 'package_detail') {
      return <div className='status-badge font-th status-badge-info'>อัพเดทข้อมูลพัสดุ</div>;
    } else if (order.shipping_status === 'problem') {
      return <div className='status-badge font-th status-badge-error'>พัสดุมีปัญหา</div>;
    } else if (order.shipping_status === 'complete') {
      return <div className='status-badge font-th status-badge-success'>จัดส่งสำเร็จ</div>;
    } else if (order.shipping_status === 'return') {
      return <div className='status-badge font-th status-badge-error'>พัสดุถูกตีกลับต้นทาง</div>;
    } else {
      // Show 'shipping' status for shops with active fulfillment provider
      if (order.has_fulfillment === true) {
        return <div className='status-badge font-th status-badge-info'>กำลังจัดส่ง</div>;
      }
      return <div className='status-badge font-th status-badge-gray'>ไม่ทราบสถานะขนส่ง</div>;
    }
  } else if (order.order_status === 'PC_RCV') {
    return <div className='status-badge font-th status-badge-success'>ผู้ซื้อรับสินค้าแล้ว</div>;
  } else if (order.order_status === 'PC_RCV_TransBack') {
    return <div className='status-badge font-th status-badge-success'>ผู้ขายรับพัสดุตีกลับแล้ว</div>;
  } else if (order.order_status === 'PC_RTN_Refunded') {
    return <div className='status-badge font-th status-badge-success'>โอนส่วนต่างคืนสินค้าแล้ว</div>;
  } else if (order.order_status === 'PC_RTN_Prepare') {
    return <div className='status-badge font-th status-badge-pending'>ผู้ซื้อเตรียมคืนสินค้า</div>;
  } else if (order.order_status === 'PC_RTN_Req') {
    return <div className='status-badge font-th status-badge-pending'>ผู้ซื้อขอคืนสินค้า</div>;
  } else if (order.order_status === 'PC_RTN_AC') {
    return <div className='status-badge font-th status-badge-info'>ผู้ขายตอบรับการคืนสินค้า</div>;
  } else if (order.order_status === 'PC_RTN_Book') {
    return (
      <div className='status-badge font-th status-badge-info'>ผู้ซื้อเตรียมเตรียมพัสดุส่งคืน</div>
    );
  } else if (order.order_status === 'PC_RTN_BookConfirm') {
    if (order.return_status === 'pending') {
      return <div className='status-badge font-th status-badge-info'>กำลังจัดส่งคืนผู้ขาย</div>;
    } else if (order.return_status === 'booking') {
      return <div className='status-badge font-th status-badge-info'>กำลังจัดส่งคืนผู้ขาย</div>;
    } else if (order.return_status === 'shipping') {
      return <div className='status-badge font-th status-badge-info'>อยู่ระหว่างขนส่ง</div>;
    } else if (order.return_status === 'package_detail') {
      return <div className='status-badge font-th status-badge-info'>อัพเดทข้อมูลพัสดุ</div>;
    } else if (order.return_status === 'problem') {
      return <div className='status-badge font-th status-badge-error'>พัสดุมีปัญหา</div>;
    } else if (order.return_status === 'complete') {
      return <div className='status-badge font-th status-badge-success'>จัดส่งสำเร็จ</div>;
    } else if (order.return_status === 'return') {
      return <div className='status-badge font-th status-badge-error'>พัสดุถูกตีกลับต้นทาง</div>;
    } else {
      return <div className='status-badge font-th status-badge-gray'>ไม่ทราบสถานะขนส่งการคืน</div>;
    }
  } else if (order.order_status === 'PC_RTN_RCV') {
    return <div className='status-badge font-th status-badge-success'>ผู้ขายรับสินค้าคืนแล้ว</div>;
  } else if (order.order_status === 'PC_RTN_Refunded') {
    return <div className='status-badge font-th status-badge-success'>โอนส่วนต่างคืนสินค้าแล้ว</div>;
  } else {
    return <div className='status-badge font-th status-badge-gray'>ไม่ทราบสถานะ</div>;
  }
}
